function Close() {
  let modalContainer = document.getElementById('modal-container');
  if (modalContainer.hasChildNodes()) {
    modalContainer.removeChild(modalContainer.lastChild);
  }
}

export default Close;
